import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSidebarRecentItemsEligibility } from '#pplx/frontend/apps/ask/hooks/recent-items-query-hooks/useSidebarRecentItemsEligibility.js';
import { SidebarV2Context, SIDEBAR_V2_FLAG, } from '#pplx/frontend/apps/ask/hooks/sidebar-graphql-v2/context.js';
import { SidebarV2DataLoader } from '#pplx/frontend/apps/ask/hooks/sidebar-graphql-v2/SidebarV2DataLoader.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { getCachedFlagValueKey } from '#pplx/frontend/experimentation/cachedFlagValue.js';
import { makeCachedFlagValueHook, useBooleanFlagValue, } from '#pplx/frontend/experimentation/hooks.js';
import { useCallback, useMemo, useState } from 'react';
const useSidebarV2Flag = (params) => useBooleanFlagValue({ ...params, flag: SIDEBAR_V2_FLAG });
const useCachedSidebarV2Flag = makeCachedFlagValueHook(getCachedFlagValueKey(SIDEBAR_V2_FLAG), useSidebarV2Flag, SIDEBAR_V2_FLAG);
const noop = () => { };
export function SidebarV2Provider({ children, filter = 'all', visible = true, }) {
    const { session } = useSession();
    const { signedIn, isIncognito, isMobileStyle } = useSidebarRecentItemsEligibility('sidebar-graphql-v2');
    const eligible = signedIn && !isIncognito;
    const flag = useCachedSidebarV2Flag({ defaultValue: false, skip: !eligible });
    const viewer = String(session?.user?.id ?? '');
    const enabled = eligible && flag;
    const [snapshot, setSnapshot] = useState(null);
    const onData = useCallback((value) => setSnapshot({ viewer, value }), [viewer]);
    const loading = useMemo(() => ({
        active: false,
        recentsFilter: filter,
        pins: { data: null, status: 'loading' },
        recents: { data: null, status: 'loading' },
        projects: [],
        projectsHasData: false,
        projectsLoading: true,
        projectsError: false,
        projectsHasNextPage: false,
        projectsLoadingMore: false,
        loadMoreProjects: noop,
        retry: noop,
    }), [filter]);
    const value = enabled && snapshot?.viewer === viewer ? snapshot.value : loading;
    return (_jsxs(SidebarV2Context.Provider, { value: enabled ? value : null, children: [enabled && (_jsx(SidebarV2DataLoader, { viewer: viewer, filter: filter, enabled: !isMobileStyle || visible, onData: onData }, viewer)), children] }));
}
//# sourceMappingURL=SidebarV2Provider.js.map